import { ApplePayInfo } from './apple-pay-info';
import { GooglePayInfo } from './google-pay-info';

export type WalletPaymentMethodInfo = ApplePayInfo | GooglePayInfo;
